import * as TooltipActions from 'actions/tooltip';
import * as actions from 'actions/response';
import * as caruselActions from 'action-creators/carousel';
import * as _ from 'lodash';
import { favoriteAdd, favoriteDel } from '../services/api/user/favorite';

export function createAndShowTooltip(tooltipData, event) {
  return (dispatch, getState) => {
    const w = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0,
    );
    const h = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0,
    );

    let xoffset;
    let yoffset;

    if (event.currentTarget && event.currentTarget.clientWidth) {
      xoffset = event.currentTarget.clientWidth + 10;

      if (event.pageX > w - event.pageX) {
        xoffset = -event.currentTarget.clientWidth - 30;
      }
      if (event.pageY > h - event.pageY) {
        yoffset = -event.currentTarget.clientHeight - 30;
      }
    }

    const supportPageOffset = window.pageYOffset !== undefined;
    const yScroll = supportPageOffset ? window.pageYOffset : window.scrollY;

    const cuadro = event.currentTarget.getBoundingClientRect();
    yoffset = yScroll + cuadro.top + cuadro.height / 4;
    xoffset = cuadro.right + 5;

    let withRi = null;
    if (xoffset + 330 > window.innerWidth && window.innerWidth > 330) {
      withRi = true;
      xoffset = cuadro.left - 335;
    }

    window.avoidTooltilTimer = false;

    const { favorites } = getState();
    const isFavorite = _.findIndex(favorites, { id: tooltipData.id }) !== -1;

    window.mouseOverTooltipTimeout = setTimeout(() => {
      dispatch({
        type: TooltipActions.CREATE_AND_SHOW_TOOLTIP,
        tooltipData,
        isFavorite,
        eventData: event,
        position: {
          xoffset,
          yoffset,
          withRi,
        },
      });
    }, 300);
  };
}

export function overTooltip() {
  return dispatch => {
    dispatch({ type: TooltipActions.OVER_TOOLTIP });
  };
}

export function mouseLeaveTooltip() {
  return dispatch => {
    dispatch({ type: TooltipActions.ON_MOUSE_LEAVE_TOOLTIP });
  };
}

export function deleteTooltip() {
  return (dispatch, getState) => {
    const { isOverTooltip } = getState().newTooltip;
    if (!isOverTooltip) {
      dispatch({ type: TooltipActions.DELETE_TOOLTIP });
    }
  };
}

export function addFavorite(params, group) {
  return async dispatch => {
    dispatch({ type: TooltipActions.FAVORITE_REQUEST_INIT });
    dispatch(actions.addFavorite(group));
    dispatch(favoriteAdd(params));
    dispatch({ type: TooltipActions.FAVORITE_REQUEST_SUCCESS });
    dispatch({ type: TooltipActions.TOOGLE_IS_FAVORITE });
  };
}

export function deleteFavorite(params, group) {
  return async dispatch => {
    dispatch({ type: TooltipActions.FAVORITE_REQUEST_INIT });
    dispatch(caruselActions.deleteFavorite(group.id));
    dispatch(actions.removeFavorite(group));
    dispatch(favoriteDel(params));
    dispatch({ type: TooltipActions.FAVORITE_REQUEST_SUCCESS });
    dispatch({ type: TooltipActions.TOOGLE_IS_FAVORITE });
  };
}
